module.exports = __webpack_public_path__ + "static/img/14003009.e67c1957.png";